import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Trophy = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M20 4h-2V2H6.005l-.01 2H4c-1.103 0-2 .897-2 2v2c0 2.123 1.211 6.685 4.749 6.972A6.03 6.03 0 0 0 11 17.935V20H9v2h6v-2h-2v-2.072a6.024 6.024 0 0 0 4.188-2.922C20.541 14.838 22 10.328 22 8V6c0-1.103-.897-2-2-2zM4 8V6h1.986l-.028 6c0 .226.015.447.039.666C4.505 11.704 4 8.907 4 8zm14 4.695v-.674h-.001L18 12V6h2v2c0 1.224-.678 3.788-2 4.695z", key: "k0" })));
});
Trophy.displayName = 'Trophy';
export var TrophyDimensions = { height: 24, width: 24 };
